import WelligenceLogoTransparentWhite from '@assets/images/welligence-transparent-white.png';
import { Box, Card, Typography } from '@mui/material';
import type { Theme } from '@mui/system';

export const CoverPage = () => {
  return (
    <Card
      sx={{
        aspectRatio: '16/9',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: (theme: Theme) => theme.palette.baseColors.deepSeaNavy.c100,
        padding: 4,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <img src={WelligenceLogoTransparentWhite} alt='Welligence Logo' />
        </Box>
        <Typography
          sx={{
            color: '#FFFFFF',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.1em',
            textAlign: 'center',
            marginTop: 2,
          }}
        >
          SETTING THE STANDARD IN ENERGY RESEARCH AND ANALYTICS
        </Typography>
      </Box>
    </Card>
  );
};
